<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目审批</template>
                            <FormItem label="">
                                <RadioGroup v-model="Forms.ex_status" type="button" button-style="solid">
                                    <Radio :label="7">通过审批</Radio>
                                    <Radio :label="2">未通过审批</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem v-if="Forms.ex_status === 2" label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                            </FormItem>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="项目名称：">
                                    {{detail.name}}
                                </Description>
                                <Description term="项目类型：">
                                    <Tag>{{detail.type_name}}</Tag>
                                </Description>
                                <Description term="项目金额：">
                                    <Tag color="primary">{{detail.money}}</Tag>
                                </Description>
                                <Description term="合同金额：">
                                    <Tag color="green">{{detail.contract_money}}</Tag>
                                </Description>
                                <Description term="甲方签署人：">
                                    {{detail.contract_signa_name}}
                                </Description>
                                <Description term="合同有效期：">
                                    {{detail.contract_start_time}} ~ {{detail.contract_end_time}}
                                </Description>
                                <Description term="甲方：">
                                    {{detail.company}}
                                </Description>
                                <Description term="联系人：">
                                    {{detail.customer_real_name}}
                                </Description>
                                <Description term="联系电话：">
                                    {{detail.customer_mobile}}
                                </Description>
                                <Description term="微信账号：">
                                    {{detail.customer_wechat}}
                                </Description>
                                <Description term="负责人：">
                                    {{detail.head_name}}
                                </Description>
                                <Description term="合同资料：">
                                    <Tag v-if="detail.contract_file" class="cursor" color="primary" @click="FileDownload(detail.contract_file)">点击下载项目资料</Tag>
                                    <small v-else>未上传</small>
                                </Description>
                                <Description term="项目周期：" v-if="detail.project_cycle">
                                    <Tag color="orange">{{detail.project_cycle}}</Tag>
                                </Description>
                                <Description term="备注信息：">
                                    {{detail.remark}}
                                </Description>
                            </DescriptionList>
                        </Card>
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目说明</template>
                            <div class="textarea-wrap">{{detail.project_desc}}</div>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">审批</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {initExamine, getProjectContentDetail} from "@/apis/project";

export default {
    name: 'ProjectInitExamine',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '项目审批',
            isBox : false,
            detail: [],
            site_url : this.$siteApi,
            Forms : {
                project_id: '',
                reject_remark: '',
                ex_status: 7
            }
        }
    },
    methods: {
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getProjectContentDetail(project_id).then(e => {
                that.detail = e.data;
            })
        },

        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(project_id, name){
            this.isBox = true;
            this.title = name + ' - 项目审批';
            if(project_id){
                this.Forms.project_id = project_id;
                this.GetDetail(project_id);
            }
        },
        /**
         功能：
         time: 2025/12/20 09:24
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    initExamine(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },

        FormReset(){
            this.isBox = false;
            this.title = '项目审批';
            this.$refs['Forms'].resetFields();
            this.Forms.project_id = '';
            this.Forms.ex_status = 7;
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
